import type { ReactNode } from 'react';
import { navigate } from '../lib.ts';

export function Link({ to, children, className, testId }: { to: string; children: ReactNode; className?: string; testId?: string }) {
  return (
    <a
      href={to}
      className={className}
      data-testid={testId}
      onClick={(e) => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        e.preventDefault();
        navigate(to);
      }}
    >
      {children}
    </a>
  );
}
